import { render, staticRenderFns } from "./NavigationItem.vue?vue&type=template&id=ab6c6cec&"
import script from "./NavigationItem.vue?vue&type=script&lang=js&"
export * from "./NavigationItem.vue?vue&type=script&lang=js&"
import style0 from "./NavigationItem.vue?vue&type=style&index=0&id=ab6c6cec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
